/*!
 * 
 *   react-simple-keyboard v2.5.186
 *   https://github.com/hodgef/react-simple-keyboard
 * 
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */
!function (t, e) {
  "object" === typeof exports && "object" === typeof module ? module.exports = e(require("react")) : "function" === typeof define && define.amd ? define("ReactSimpleKeyboard", ["react"], e) : "object" === typeof exports ? exports.ReactSimpleKeyboard = e(require("react")) : t.ReactSimpleKeyboard = e(t.React);
}(this, function (t) {
  return function (t) {
    var e = {};

    function __webpack_require__(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }

    return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, n) {
      __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (t, e) {
      if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
      if (4 & e && "object" === typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        __webpack_require__.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, __webpack_require__.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return __webpack_require__.d(e, "a", e), e;
    }, __webpack_require__.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 3);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    (function (t) {
      var o,
          i,
          r,
          s,
          a = n(5);
      s = function s() {
        return function (t) {
          var e = {};

          function __webpack_require__(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return t[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
          }

          return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, n) {
            __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
              enumerable: !0,
              get: n
            });
          }, __webpack_require__.r = function (t) {
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }, __webpack_require__.t = function (t, e) {
            if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
            if (4 & e && "object" === a(t) && t && t.__esModule) return t;
            var n = Object.create(null);
            if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: t
            }), 2 & e && "string" != typeof t) for (var o in t) {
              __webpack_require__.d(n, o, function (e) {
                return t[e];
              }.bind(null, o));
            }
            return n;
          }, __webpack_require__.n = function (t) {
            var e = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return __webpack_require__.d(e, "a", e), e;
          }, __webpack_require__.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 0);
        }([function (t, e, n) {
          t.exports = n(1);
        }, function (t, e, n) {
          "use strict";

          function _arrayLikeToArray(t, e) {
            (null == e || e > t.length) && (e = t.length);

            for (var n = 0, o = new Array(e); n < e; n++) {
              o[n] = t[n];
            }

            return o;
          }

          function _typeof(t) {
            return (_typeof = "function" === typeof Symbol && "symbol" === a(Symbol.iterator) ? function (t) {
              return a(t);
            } : function (t) {
              return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : a(t);
            })(t);
          }

          function _defineProperties(t, e) {
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
            }
          }

          n.r(e);

          var o,
              i,
              r,
              s = function () {
            function Utilities(t) {
              var e = t.getOptions,
                  n = t.getCaretPosition,
                  o = t.getCaretPositionEnd,
                  i = t.dispatch;
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, Utilities), this.getOptions = e, this.getCaretPosition = n, this.getCaretPositionEnd = o, this.dispatch = i, Utilities.bindMethods(Utilities, this);
            }

            var t, e, n;
            return t = Utilities, n = [{
              key: "bindMethods",
              value: function value(t, e) {
                var n,
                    o = function (t, e) {
                  var _n;

                  if ("undefined" === typeof Symbol || null == t[Symbol.iterator]) {
                    if (Array.isArray(t) || (_n = function (t, e) {
                      if (t) {
                        if ("string" === typeof t) return _arrayLikeToArray(t, e);
                        var n = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(t, e) : void 0;
                      }
                    }(t)) || e && t && "number" === typeof t.length) {
                      _n && (t = _n);

                      var o = 0,
                          F = function F() {};

                      return {
                        s: F,
                        n: function n() {
                          return o >= t.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: t[o++]
                          };
                        },
                        e: function e(t) {
                          throw t;
                        },
                        f: F
                      };
                    }

                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }

                  var i,
                      r = !0,
                      s = !1;
                  return {
                    s: function s() {
                      _n = t[Symbol.iterator]();
                    },
                    n: function n() {
                      var t = _n.next();

                      return r = t.done, t;
                    },
                    e: function e(t) {
                      s = !0, i = t;
                    },
                    f: function f() {
                      try {
                        r || null == _n.return || _n.return();
                      } finally {
                        if (s) throw i;
                      }
                    }
                  };
                }(Object.getOwnPropertyNames(t.prototype));

                try {
                  for (o.s(); !(n = o.n()).done;) {
                    var i = n.value;
                    "constructor" === i || "bindMethods" === i || (e[i] = e[i].bind(e));
                  }
                } catch (r) {
                  o.e(r);
                } finally {
                  o.f();
                }
              }
            }], (e = [{
              key: "getButtonClass",
              value: function value(t) {
                var e = t.includes("{") && t.includes("}") && "{//}" !== t ? "functionBtn" : "standardBtn",
                    n = t.replace("{", "").replace("}", ""),
                    o = "";
                return "standardBtn" !== e && (o = " hg-button-".concat(n)), "hg-".concat(e).concat(o);
              }
            }, {
              key: "getDefaultDiplay",
              value: function value() {
                return {
                  "{bksp}": "backspace",
                  "{backspace}": "backspace",
                  "{enter}": "< enter",
                  "{shift}": "shift",
                  "{shiftleft}": "shift",
                  "{shiftright}": "shift",
                  "{alt}": "alt",
                  "{s}": "shift",
                  "{tab}": "tab",
                  "{lock}": "caps",
                  "{capslock}": "caps",
                  "{accept}": "Submit",
                  "{space}": " ",
                  "{//}": " ",
                  "{esc}": "esc",
                  "{escape}": "esc",
                  "{f1}": "f1",
                  "{f2}": "f2",
                  "{f3}": "f3",
                  "{f4}": "f4",
                  "{f5}": "f5",
                  "{f6}": "f6",
                  "{f7}": "f7",
                  "{f8}": "f8",
                  "{f9}": "f9",
                  "{f10}": "f10",
                  "{f11}": "f11",
                  "{f12}": "f12",
                  "{numpaddivide}": "/",
                  "{numlock}": "lock",
                  "{arrowup}": "\u2191",
                  "{arrowleft}": "\u2190",
                  "{arrowdown}": "\u2193",
                  "{arrowright}": "\u2192",
                  "{prtscr}": "print",
                  "{scrolllock}": "scroll",
                  "{pause}": "pause",
                  "{insert}": "ins",
                  "{home}": "home",
                  "{pageup}": "up",
                  "{delete}": "del",
                  "{end}": "end",
                  "{pagedown}": "down",
                  "{numpadmultiply}": "*",
                  "{numpadsubtract}": "-",
                  "{numpadadd}": "+",
                  "{numpadenter}": "enter",
                  "{period}": ".",
                  "{numpaddecimal}": ".",
                  "{numpad0}": "0",
                  "{numpad1}": "1",
                  "{numpad2}": "2",
                  "{numpad3}": "3",
                  "{numpad4}": "4",
                  "{numpad5}": "5",
                  "{numpad6}": "6",
                  "{numpad7}": "7",
                  "{numpad8}": "8",
                  "{numpad9}": "9"
                };
              }
            }, {
              key: "getButtonDisplayName",
              value: function value(t, e, n) {
                return (e = n ? Object.assign({}, this.getDefaultDiplay(), e) : e || this.getDefaultDiplay())[t] || t;
              }
            }, {
              key: "getUpdatedInput",
              value: function value(t, e, n) {
                var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n,
                    i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                    r = this.getOptions(),
                    s = [n, o, i],
                    a = e;
                return ("{bksp}" === t || "{backspace}" === t) && a.length > 0 ? a = this.removeAt.apply(this, [a].concat(s)) : "{space}" === t ? a = this.addStringAt.apply(this, [a, " "].concat(s)) : "{tab}" !== t || "boolean" === typeof r.tabCharOnTab && !1 === r.tabCharOnTab ? "{enter}" !== t && "{numpadenter}" !== t || !r.newLineOnEnter ? t.includes("numpad") && Number.isInteger(Number(t[t.length - 2])) ? a = this.addStringAt.apply(this, [a, t[t.length - 2]].concat(s)) : "{numpaddivide}" === t ? a = this.addStringAt.apply(this, [a, "/"].concat(s)) : "{numpadmultiply}" === t ? a = this.addStringAt.apply(this, [a, "*"].concat(s)) : "{numpadsubtract}" === t ? a = this.addStringAt.apply(this, [a, "-"].concat(s)) : "{numpadadd}" === t ? a = this.addStringAt.apply(this, [a, "+"].concat(s)) : "{numpaddecimal}" === t ? a = this.addStringAt.apply(this, [a, "."].concat(s)) : "{" === t || "}" === t ? a = this.addStringAt.apply(this, [a, t].concat(s)) : t.includes("{") || t.includes("}") || (a = this.addStringAt.apply(this, [a, t].concat(s))) : a = this.addStringAt.apply(this, [a, "\n"].concat(s)) : a = this.addStringAt.apply(this, [a, "\t"].concat(s)), a;
              }
            }, {
              key: "updateCaretPos",
              value: function value(t, e) {
                var n = this.updateCaretPosAction(t, e);
                this.dispatch(function (t) {
                  t.setCaretPosition(n);
                });
              }
            }, {
              key: "updateCaretPosAction",
              value: function value(t, e) {
                var n = this.getOptions(),
                    o = this.getCaretPosition();
                return e ? o > 0 && (o -= t) : o += t, n.debug && console.log("Caret at:", o, "(".concat(this.keyboardDOMClass, ")")), o;
              }
            }, {
              key: "addStringAt",
              value: function value(t, e) {
                var n,
                    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length,
                    i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length,
                    r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return o || 0 === o ? (n = [t.slice(0, o), e, t.slice(i)].join(""), this.isMaxLengthReached() || r && this.updateCaretPos(e.length)) : n = t + e, n;
              }
            }, {
              key: "removeAt",
              value: function value(t) {
                var e,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length,
                    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length,
                    i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                if (0 === n && 0 === o) return t;

                if (n === o) {
                  var r = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                  n && n >= 0 ? t.substring(n - 2, n).match(r) ? (e = t.substr(0, n - 2) + t.substr(n), i && this.updateCaretPos(2, !0)) : (e = t.substr(0, n - 1) + t.substr(n), i && this.updateCaretPos(1, !0)) : t.slice(-2).match(r) ? (e = t.slice(0, -2), i && this.updateCaretPos(2, !0)) : (e = t.slice(0, -1), i && this.updateCaretPos(1, !0));
                } else e = t.slice(0, n) + t.slice(o), i && this.dispatch(function (t) {
                  t.setCaretPosition(n);
                });

                return e;
              }
            }, {
              key: "handleMaxLength",
              value: function value(t, e) {
                var n = this.getOptions(),
                    o = n.maxLength,
                    i = t[n.inputName],
                    r = e.length - 1 >= o;
                if (e.length <= i.length) return !1;
                if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", r), r ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);

                if ("object" === _typeof(o)) {
                  var s = e.length - 1 >= o[n.inputName];
                  return n.debug && console.log("maxLength (obj) reached:", s), s ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                }
              }
            }, {
              key: "isMaxLengthReached",
              value: function value() {
                return Boolean(this.maxLengthReached);
              }
            }, {
              key: "isTouchDevice",
              value: function value() {
                return "ontouchstart" in window || navigator.maxTouchPoints;
              }
            }, {
              key: "pointerEventsSupported",
              value: function value() {
                return window.PointerEvent;
              }
            }, {
              key: "camelCase",
              value: function value(t) {
                return !!t && t.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function (t, e) {
                  return e.length ? t + e[0].toUpperCase() + e.slice(1) : t;
                });
              }
            }]) && _defineProperties(t.prototype, e), n && _defineProperties(t, n), Utilities;
          }();

          r = function r() {}, (i = "noop") in (o = s) ? Object.defineProperty(o, i, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : o[i] = r;
          var u = s;

          function PhysicalKeyboard_defineProperties(t, e) {
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
            }
          }

          var c = function () {
            function PhysicalKeyboard(t) {
              var e = t.dispatch,
                  n = t.getOptions;
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, PhysicalKeyboard), this.dispatch = e, this.getOptions = n, u.bindMethods(PhysicalKeyboard, this);
            }

            var t, e;
            return t = PhysicalKeyboard, (e = [{
              key: "handleHighlightKeyDown",
              value: function value(t) {
                var e = this.getOptions(),
                    n = this.getSimpleKeyboardLayoutKey(t);
                this.dispatch(function (t) {
                  var o = t.getButtonElement(n) || t.getButtonElement("{".concat(n, "}"));
                  o && (o.style.backgroundColor = e.physicalKeyboardHighlightBgColor || "#dadce4", o.style.color = e.physicalKeyboardHighlightTextColor || "black", e.physicalKeyboardHighlightPress && (o.onpointerdown || o.onmousedown || o.ontouchstart || u.noop)());
                });
              }
            }, {
              key: "handleHighlightKeyUp",
              value: function value(t) {
                var e = this.getOptions(),
                    n = this.getSimpleKeyboardLayoutKey(t);
                this.dispatch(function (t) {
                  var o = t.getButtonElement(n) || t.getButtonElement("{".concat(n, "}"));
                  o && o.removeAttribute && (o.removeAttribute("style"), e.physicalKeyboardHighlightPress && (o.onpointerup || o.onmouseup || o.ontouchend || u.noop)());
                });
              }
            }, {
              key: "getSimpleKeyboardLayoutKey",
              value: function value(t) {
                var e;
                return ((e = t.code.includes("Numpad") || t.code.includes("Shift") || t.code.includes("Space") || t.code.includes("Backspace") || t.code.includes("Control") || t.code.includes("Alt") || t.code.includes("Meta") ? t.code : t.key) && e !== e.toUpperCase() || "F" === t.code[0] && Number.isInteger(Number(t.code[1])) && t.code.length <= 3) && (e = e ? e.toLowerCase() : e), e;
              }
            }]) && PhysicalKeyboard_defineProperties(t.prototype, e), PhysicalKeyboard;
          }();

          function _toConsumableArray(t) {
            return function (t) {
              if (Array.isArray(t)) return Keyboard_arrayLikeToArray(t);
            }(t) || function (t) {
              if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
            }(t) || function (t, e) {
              if (t) {
                if ("string" === typeof t) return Keyboard_arrayLikeToArray(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Keyboard_arrayLikeToArray(t, e) : void 0;
              }
            }(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }

          function Keyboard_arrayLikeToArray(t, e) {
            (null == e || e > t.length) && (e = t.length);

            for (var n = 0, o = new Array(e); n < e; n++) {
              o[n] = t[n];
            }

            return o;
          }

          function Keyboard_classCallCheck(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }

          function Keyboard_defineProperties(t, e) {
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
            }
          }

          function Keyboard_defineProperty(t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = n, t;
          }

          var l = function () {
            function SimpleKeyboard() {
              var t = this;
              Keyboard_classCallCheck(this, SimpleKeyboard), Keyboard_defineProperty(this, "handleParams", function (t) {
                var e, n, o;
                if ("string" === typeof t[0]) e = t[0].split(".").join(""), n = document.querySelector(".".concat(e)), o = t[1];else if (t[0] instanceof HTMLDivElement) {
                  if (!t[0].className) throw console.warn("Any DOM element passed as parameter must have a class."), new Error("KEYBOARD_DOM_CLASS_ERROR");
                  e = t[0].className.split(" ")[0], n = t[0], o = t[1];
                } else e = "simple-keyboard", n = document.querySelector(".".concat(e)), o = t[0];
                return {
                  keyboardDOMClass: e,
                  keyboardDOM: n,
                  options: o
                };
              }), Keyboard_defineProperty(this, "getOptions", function () {
                return t.options;
              }), Keyboard_defineProperty(this, "getCaretPosition", function () {
                return t.caretPosition;
              }), Keyboard_defineProperty(this, "getCaretPositionEnd", function () {
                return t.caretPositionEnd;
              }), Keyboard_defineProperty(this, "registerModule", function (e, n) {
                t.modules[e] || (t.modules[e] = {}), n(t.modules[e]);
              }), Keyboard_defineProperty(this, "getKeyboardClassString", function () {
                for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
                  n[o] = arguments[o];
                }

                var i = [t.keyboardDOMClass].concat(n).filter(function (t) {
                  return !!t;
                });
                return i.join(" ");
              });

              for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
                n[o] = arguments[o];
              }

              var i = this.handleParams(n),
                  r = i.keyboardDOMClass,
                  s = i.keyboardDOM,
                  a = i.options,
                  l = void 0 === a ? {} : a;
              if (this.utilities = new u({
                getOptions: this.getOptions,
                getCaretPosition: this.getCaretPosition,
                getCaretPositionEnd: this.getCaretPositionEnd,
                dispatch: this.dispatch
              }), this.caretPosition = null, this.caretPositionEnd = null, this.keyboardDOM = s, this.options = l, this.options.layoutName = this.options.layoutName || "default", this.options.theme = this.options.theme || "hg-theme-default", this.options.inputName = this.options.inputName || "default", this.options.preventMouseDownDefault = this.options.preventMouseDownDefault || !1, this.keyboardPluginClasses = "", u.bindMethods(SimpleKeyboard, this), this.input = {}, this.input[this.options.inputName] = "", this.keyboardDOMClass = r, this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), window.SimpleKeyboardInstances[this.currentInstanceName] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new c({
                dispatch: this.dispatch,
                getOptions: this.getOptions
              }), !this.keyboardDOM) throw console.warn('".'.concat(r, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
              this.render(), this.modules = {}, this.loadModules();
            }

            var t, e;
            return t = SimpleKeyboard, (e = [{
              key: "setCaretPosition",
              value: function value(t, e) {
                this.caretPosition = t, this.caretPositionEnd = e || t;
              }
            }, {
              key: "handleButtonClicked",
              value: function value(t) {
                var e = this.options.debug;
                if ("{//}" === t) return !1;
                "function" === typeof this.options.onKeyPress && this.options.onKeyPress(t), this.input[this.options.inputName] || (this.input[this.options.inputName] = "");
                var n = this.utilities.getUpdatedInput(t, this.input[this.options.inputName], this.caretPosition, this.caretPositionEnd);

                if (this.input[this.options.inputName] !== n && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(n))) {
                  if (this.options.maxLength && this.utilities.handleMaxLength(this.input, n)) return !1;
                  this.input[this.options.inputName] = this.utilities.getUpdatedInput(t, this.input[this.options.inputName], this.caretPosition, this.caretPositionEnd, !0), e && console.log("Input changed:", this.getAllInputs()), this.options.debug && console.log("Caret at: ", this.getCaretPosition(), this.getCaretPositionEnd(), "(".concat(this.keyboardDOMClass, ")")), this.options.syncInstanceInputs && this.syncInstanceInputs(), "function" === typeof this.options.onChange && this.options.onChange(this.getInput(this.options.inputName, !0)), "function" === typeof this.options.onChangeAll && this.options.onChangeAll(this.getAllInputs());
                }

                e && console.log("Key pressed:", t);
              }
            }, {
              key: "handleButtonMouseDown",
              value: function value(t, e) {
                var n = this;
                e && (this.options.preventMouseDownDefault && e.preventDefault(), this.options.stopMouseDownPropagation && e.stopPropagation(), e.target.classList.add(this.activeButtonClass)), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.isMouseHold = !0, this.options.disableButtonHold || (this.holdTimeout = setTimeout(function () {
                  (n.isMouseHold && (!t.includes("{") && !t.includes("}") || "{delete}" === t || "{backspace}" === t || "{bksp}" === t || "{space}" === t || "{tab}" === t) || "{arrowright}" === t || "{arrowleft}" === t || "{arrowup}" === t || "{arrowdown}" === t) && (n.options.debug && console.log("Button held:", t), n.handleButtonHold(t, e)), clearTimeout(n.holdTimeout);
                }, 500));
              }
            }, {
              key: "handleButtonMouseUp",
              value: function value() {
                var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                n && (this.options.preventMouseUpDefault && n.preventDefault(), this.options.stopMouseUpPropagation && n.stopPropagation()), this.recurseButtons(function (e) {
                  e.classList.remove(t.activeButtonClass);
                }), this.isMouseHold = !1, this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), e && "function" === typeof this.options.onKeyReleased && this.options.onKeyReleased(e);
              }
            }, {
              key: "handleKeyboardContainerMouseDown",
              value: function value(t) {
                this.options.preventMouseDownDefault && t.preventDefault();
              }
            }, {
              key: "handleButtonHold",
              value: function value(t) {
                var e = this;
                this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = setTimeout(function () {
                  e.isMouseHold ? (e.handleButtonClicked(t), e.handleButtonHold(t)) : clearTimeout(e.holdInteractionTimeout);
                }, 100);
              }
            }, {
              key: "syncInstanceInputs",
              value: function value() {
                var t = this;
                this.dispatch(function (e) {
                  e.replaceInput(t.input), e.setCaretPosition(t.caretPosition, t.caretPositionEnd);
                });
              }
            }, {
              key: "clearInput",
              value: function value(t) {
                t = t || this.options.inputName, this.input[t] = "", this.setCaretPosition(0), this.options.syncInstanceInputs && this.syncInstanceInputs();
              }
            }, {
              key: "getInput",
              value: function value(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

                if (t = t || this.options.inputName, this.options.syncInstanceInputs && !e && this.syncInstanceInputs(), this.options.rtl) {
                  var n = this.input[t].replace("\u202B", "").replace("\u202C", "");
                  return "\u202B" + n + "\u202C";
                }

                return this.input[t];
              }
            }, {
              key: "getAllInputs",
              value: function value() {
                var t = this,
                    e = {};
                return Object.keys(this.input).forEach(function (n) {
                  e[n] = t.getInput(n, !0);
                }), e;
              }
            }, {
              key: "setInput",
              value: function value(t, e) {
                e = e || this.options.inputName, this.input[e] = t, this.options.syncInstanceInputs && this.syncInstanceInputs();
              }
            }, {
              key: "replaceInput",
              value: function value(t) {
                this.input = t;
              }
            }, {
              key: "setOptions",
              value: function value() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    e = this.changedOptions(t);
                this.options = Object.assign(this.options, t), e.length && (this.options.debug && console.log("changedOptions", e), this.onSetOptions(t), this.render());
              }
            }, {
              key: "changedOptions",
              value: function value(t) {
                var e = this;
                return Object.keys(t).filter(function (n) {
                  return JSON.stringify(t[n]) !== JSON.stringify(e.options[n]);
                });
              }
            }, {
              key: "onSetOptions",
              value: function value(t) {
                t.inputName && (this.options.debug && console.log("inputName changed. caretPosition reset."), this.setCaretPosition(null));
              }
            }, {
              key: "clear",
              value: function value() {
                this.keyboardDOM.innerHTML = "", this.keyboardDOM.className = this.keyboardDOMClass, this.buttonElements = {};
              }
            }, {
              key: "dispatch",
              value: function value(t) {
                if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                return Object.keys(window.SimpleKeyboardInstances).forEach(function (e) {
                  t(window.SimpleKeyboardInstances[e], e);
                });
              }
            }, {
              key: "addButtonTheme",
              value: function value(t, e) {
                var n = this;
                if (!e || !t) return !1;
                t.split(" ").forEach(function (o) {
                  e.split(" ").forEach(function (e) {
                    n.options.buttonTheme || (n.options.buttonTheme = []);
                    var i = !1;
                    n.options.buttonTheme.map(function (t) {
                      if (t.class.split(" ").includes(e)) {
                        i = !0;
                        var n = t.buttons.split(" ");
                        n.includes(o) || (i = !0, n.push(o), t.buttons = n.join(" "));
                      }

                      return t;
                    }), i || n.options.buttonTheme.push({
                      class: e,
                      buttons: t
                    });
                  });
                }), this.render();
              }
            }, {
              key: "removeButtonTheme",
              value: function value(t, e) {
                var n = this;
                if (!t && !e) return this.options.buttonTheme = [], this.render(), !1;
                t && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (t.split(" ").forEach(function (t) {
                  n.options.buttonTheme.map(function (o, i) {
                    if (e && e.includes(o.class) || !e) {
                      var r = o.buttons.split(" ").filter(function (e) {
                        return e !== t;
                      });
                      r.length ? o.buttons = r.join(" ") : (n.options.buttonTheme.splice(i, 1), o = null);
                    }

                    return o;
                  });
                }), this.render());
              }
            }, {
              key: "getButtonElement",
              value: function value(t) {
                var e,
                    n = this.buttonElements[t];
                return n && (e = n.length > 1 ? n : n[0]), e;
              }
            }, {
              key: "inputPatternIsValid",
              value: function value(t) {
                var e,
                    n = this.options.inputPattern;

                if ((e = n instanceof RegExp ? n : n[this.options.inputName]) && t) {
                  var o = e.test(t);
                  return this.options.debug && console.log('inputPattern ("'.concat(e, '"): ').concat(o ? "passed" : "did not pass!")), o;
                }

                return !0;
              }
            }, {
              key: "setEventListeners",
              value: function value() {
                !this.isFirstKeyboardInstance && this.allKeyboardInstances || (this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")")), document.addEventListener("keyup", this.handleKeyUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd));
              }
            }, {
              key: "handleKeyUp",
              value: function value(t) {
                this.caretEventHandler(t), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(t);
              }
            }, {
              key: "handleKeyDown",
              value: function value(t) {
                this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(t);
              }
            }, {
              key: "handleMouseUp",
              value: function value(t) {
                this.caretEventHandler(t);
              }
            }, {
              key: "handleTouchEnd",
              value: function value(t) {
                this.caretEventHandler(t);
              }
            }, {
              key: "caretEventHandler",
              value: function value(t) {
                var e;
                t.target.tagName && (e = t.target.tagName.toLowerCase()), this.dispatch(function (n) {
                  var o = t.target === n.keyboardDOM || t.target && n.keyboardDOM.contains(t.target);
                  n.isMouseHold && (n.isMouseHold = !1), "textarea" !== e && "input" !== e || !["text", "search", "url", "tel", "password"].includes(t.target.type) || n.options.disableCaretPositioning ? !n.options.disableCaretPositioning && o || n.setCaretPosition(null) : (n.setCaretPosition(t.target.selectionStart, t.target.selectionEnd), n.options.debug && console.log("Caret at: ", n.getCaretPosition(), n.getCaretPositionEnd(), t && t.target.tagName.toLowerCase(), "(".concat(n.keyboardDOMClass, ")")));
                });
              }
            }, {
              key: "recurseButtons",
              value: function value(t) {
                var e = this;
                t && Object.keys(this.buttonElements).forEach(function (n) {
                  return e.buttonElements[n].forEach(t);
                });
              }
            }, {
              key: "destroy",
              value: function value() {
                this.options.debug && console.log("Destroying simple-keyboard instance: ".concat(this.currentInstanceName)), document.removeEventListener("keyup", this.handleKeyUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), document.onpointerup = null, document.ontouchend = null, document.ontouchcancel = null, document.onmouseup = null;

                var deleteButton = function deleteButton(t) {
                  t.onpointerdown = null, t.onpointerup = null, t.onpointercancel = null, t.ontouchstart = null, t.ontouchend = null, t.ontouchcancel = null, t.onclick = null, t.onmousedown = null, t.onmouseup = null, t.remove(), t = null;
                };

                this.recurseButtons(deleteButton), this.recurseButtons = null, deleteButton = null, this.keyboardDOM.onpointerdown = null, this.keyboardDOM.ontouchstart = null, this.keyboardDOM.onmousedown = null, this.clear(), window.SimpleKeyboardInstances[this.currentInstanceName] = null, delete window.SimpleKeyboardInstances[this.currentInstanceName], this.initialized = !1;
              }
            }, {
              key: "getButtonThemeClasses",
              value: function value(t) {
                var e = this.options.buttonTheme,
                    n = [];
                return Array.isArray(e) && e.forEach(function (e) {
                  if (e.class && "string" === typeof e.class && e.buttons && "string" === typeof e.buttons) {
                    var o = e.class.split(" ");
                    e.buttons.split(" ").includes(t) && (n = [].concat(_toConsumableArray(n), _toConsumableArray(o)));
                  } else console.warn('Incorrect "buttonTheme". Please check the documentation.', e);
                }), n;
              }
            }, {
              key: "setDOMButtonAttributes",
              value: function value(t, e) {
                var n = this.options.buttonAttributes;
                Array.isArray(n) && n.forEach(function (n) {
                  n.attribute && "string" === typeof n.attribute && n.value && "string" === typeof n.value && n.buttons && "string" === typeof n.buttons ? n.buttons.split(" ").includes(t) && e(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                });
              }
            }, {
              key: "onTouchDeviceDetected",
              value: function value() {
                this.processAutoTouchEvents(), this.disableContextualWindow();
              }
            }, {
              key: "disableContextualWindow",
              value: function value() {
                window.oncontextmenu = function (t) {
                  if (t.target.classList.contains("hg-button")) return t.preventDefault(), t.stopPropagation(), !1;
                };
              }
            }, {
              key: "processAutoTouchEvents",
              value: function value() {
                this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
              }
            }, {
              key: "onInit",
              value: function value() {
                this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" === typeof this.options.onInit && this.options.onInit();
              }
            }, {
              key: "beforeFirstRender",
              value: function value() {
                this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" === typeof this.options.beforeFirstRender && this.options.beforeFirstRender(), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
              }
            }, {
              key: "beforeRender",
              value: function value() {
                "function" === typeof this.options.beforeRender && this.options.beforeRender();
              }
            }, {
              key: "onRender",
              value: function value() {
                "function" === typeof this.options.onRender && this.options.onRender();
              }
            }, {
              key: "onModulesLoaded",
              value: function value() {
                "function" === typeof this.options.onModulesLoaded && this.options.onModulesLoaded(this);
              }
            }, {
              key: "loadModules",
              value: function value() {
                var t = this;
                Array.isArray(this.options.modules) && (this.options.modules.forEach(function (e) {
                  new e().init(t);
                }), this.keyboardPluginClasses = "modules-loaded", this.render(), this.onModulesLoaded());
              }
            }, {
              key: "getModuleProp",
              value: function value(t, e) {
                return !!this.modules[t] && this.modules[t][e];
              }
            }, {
              key: "getModulesList",
              value: function value() {
                return Object.keys(this.modules);
              }
            }, {
              key: "parseRowDOMContainers",
              value: function value(t, e, n, o) {
                var i = this,
                    r = Array.from(t.children),
                    s = 0;
                return r.length && n.forEach(function (n, a) {
                  var u = o[a];
                  if (!u || !(u > n)) return !1;
                  var c = n - s,
                      l = u - s,
                      p = document.createElement("div");
                  p.className += "hg-button-container";
                  var h = "".concat(i.options.layoutName, "-r").concat(e, "c").concat(a);
                  p.setAttribute("data-skUID", h);
                  var d = r.splice(c, l - c + 1);
                  s = l - c, d.forEach(function (t) {
                    return p.appendChild(t);
                  }), r.splice(c, 0, p), t.innerHTML = "", r.forEach(function (e) {
                    return t.appendChild(e);
                  }), i.options.debug && console.log("rowDOMContainer", d, c, l, s + 1);
                }), t;
              }
            }, {
              key: "render",
              value: function value() {
                var t = this;
                this.clear(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                var e = "hg-layout-".concat(this.options.layoutName),
                    n = this.options.layout || {
                  default: ["` 1 2 3 4 5 6 7 8 9 0 - = {bksp}", "{tab} q w e r t y u i o p [ ] \\", "{lock} a s d f g h j k l ; ' {enter}", "{shift} z x c v b n m , . / {shift}", ".com @ {space}"],
                  shift: ["~ ! @ # $ % ^ & * ( ) _ + {bksp}", "{tab} Q W E R T Y U I O P { } |", '{lock} A S D F G H J K L : " {enter}', "{shift} Z X C V B N M < > ? {shift}", ".com @ {space}"]
                },
                    o = this.options.useTouchEvents || !1,
                    i = o ? "hg-touch-events" : "",
                    r = this.options.useMouseEvents || !1,
                    s = this.options.disableRowButtonContainers;
                this.keyboardDOM.className = this.getKeyboardClassString(this.options.theme, e, this.keyboardPluginClasses, i), n[this.options.layoutName].forEach(function (e, n) {
                  var i = e.split(" "),
                      a = document.createElement("div");
                  a.className += "hg-row";
                  var u = [],
                      c = [];
                  i.forEach(function (e, i) {
                    var l,
                        p = !s && "string" === typeof e && e.length > 1 && 0 === e.indexOf("["),
                        h = !s && "string" === typeof e && e.length > 1 && e.indexOf("]") === e.length - 1;
                    p && (u.push(i), e = e.replace(/\[/g, "")), h && (c.push(i), e = e.replace(/\]/g, ""));
                    var d = t.utilities.getButtonClass(e),
                        f = t.utilities.getButtonDisplayName(e, t.options.display, t.options.mergeDisplay),
                        y = t.options.useButtonTag ? "button" : "div",
                        b = document.createElement(y);
                    b.className += "hg-button ".concat(d), (l = b.classList).add.apply(l, _toConsumableArray(t.getButtonThemeClasses(e))), t.setDOMButtonAttributes(e, function (t, e) {
                      b.setAttribute(t, e);
                    }), t.activeButtonClass = "hg-activeButton", !t.utilities.pointerEventsSupported() || o || r ? o ? (b.ontouchstart = function (n) {
                      t.handleButtonClicked(e), t.handleButtonMouseDown(e, n);
                    }, b.ontouchend = function (n) {
                      t.handleButtonMouseUp(e, n);
                    }, b.ontouchcancel = function (n) {
                      t.handleButtonMouseUp(e, n);
                    }) : (b.onclick = function () {
                      t.isMouseHold = !1, t.handleButtonClicked(e);
                    }, b.onmousedown = function (n) {
                      t.handleButtonMouseDown(e, n);
                    }, b.onmouseup = function (n) {
                      t.handleButtonMouseUp(e, n);
                    }) : (b.onpointerdown = function (n) {
                      t.handleButtonClicked(e), t.handleButtonMouseDown(e, n);
                    }, b.onpointerup = function (n) {
                      t.handleButtonMouseUp(e, n);
                    }, b.onpointercancel = function (n) {
                      t.handleButtonMouseUp(e, n);
                    }), b.setAttribute("data-skBtn", e);
                    var m = "".concat(t.options.layoutName, "-r").concat(n, "b").concat(i);
                    b.setAttribute("data-skBtnUID", m);
                    var g = document.createElement("span");
                    g.innerHTML = f, b.appendChild(g), t.buttonElements[e] || (t.buttonElements[e] = []), t.buttonElements[e].push(b), a.appendChild(b);
                  }), a = t.parseRowDOMContainers(a, n, u, c), t.keyboardDOM.appendChild(a);
                }), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || r ? o ? (document.ontouchend = function () {
                  return t.handleButtonMouseUp();
                }, document.ontouchcancel = function () {
                  return t.handleButtonMouseUp();
                }, this.keyboardDOM.ontouchstart = function (e) {
                  return t.handleKeyboardContainerMouseDown(e);
                }) : o || (document.onmouseup = function () {
                  return t.handleButtonMouseUp();
                }, this.keyboardDOM.onmousedown = function (e) {
                  return t.handleKeyboardContainerMouseDown(e);
                }) : (document.onpointerup = function () {
                  return t.handleButtonMouseUp();
                }, this.keyboardDOM.onpointerdown = function (e) {
                  return t.handleKeyboardContainerMouseDown(e);
                }), this.onInit());
              }
            }]) && Keyboard_defineProperties(t.prototype, e), SimpleKeyboard;
          }();

          e.default = l;
        }]);
      }, "object" === a(e) && "object" === a(t) ? t.exports = s() : (i = [], void 0 === (r = "function" === typeof (o = s) ? o.apply(e, i) : o) || (t.exports = r));
    }).call(this, n(4)(t));
  }, function (t, e, n) {
    t.exports = n(6)();
  }, function (t, e, n) {
    t.exports = n(8);
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e) {
    function _typeof(e) {
      return "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? t.exports = _typeof = function _typeof(t) {
        return typeof t;
      } : t.exports = _typeof = function _typeof(t) {
        return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, _typeof(e);
    }

    t.exports = _typeof;
  }, function (t, e, n) {
    "use strict";

    var o = n(7);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, t.exports = function () {
      function shim(t, e, n, i, r, s) {
        if (s !== o) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var t = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return t.PropTypes = t, t;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var o = n(0),
        i = n.n(o),
        r = n(1),
        s = n.n(r);

    function ownKeys(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(t);
        e && (o = o.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, o);
      }

      return n;
    }

    function _objectSpread(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ownKeys(Object(n), !0).forEach(function (e) {
          _defineProperty(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function _defineProperty(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var cleanProps = function cleanProps(t) {
      return _objectSpread(_objectSpread({}, t), {}, {
        keyboardRef: null,
        stateToIgnore: null
      });
    },
        a = n(2),
        Keyboard_KeyboardReact = function Keyboard_KeyboardReact(t) {
      var e = t.baseClass || "react-simple-keyboard",
          n = Object(o.useRef)(),
          r = Object(o.useRef)(),
          a = Object(o.useRef)(t);
      return Object(o.useEffect)(function () {
        var o = function (t) {
          return _objectSpread(_objectSpread({}, t), {}, {
            theme: "simple-keyboard ".concat(t.theme || "hg-theme-default")
          });
        }(t);

        n.current || (n.current = !0, o.debug && console.log("ReactSimpleKeyboard: Init"), r.current = new s.a(".".concat(e), o), o.keyboardRef && o.keyboardRef(r.current));

        var i = function (t, e) {
          var n = cleanProps(e),
              o = cleanProps(t);
          return Object.keys(n).filter(function (t) {
            return n[t] !== o[t];
          });
        }(a.current, o);

        if (i.length) {
          var u = r.current;
          a.current = o, u.setOptions(o), o.debug && console.log("ReactSimpleKeyboard - setOptions called due to updated props:", i);
        }
      }, [n, e, a, t]), i.a.createElement("div", {
        className: e
      });
    };

    Keyboard_KeyboardReact.propTypes = {
      baseClass: n.n(a).a.string
    };
    var u = Keyboard_KeyboardReact;
    e.default = u;
  }]);
});